import httpClient from '@/lib/httpClient'
import useAuthStore from '@/store/useAuthStore'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useTwoFactorChallenge({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()
  const authenticate = useAuthStore((state) => state.authenticate)

  const action = async ({
    code,
    recoveryCode,
  }: {
    code: string | undefined
    recoveryCode: string | undefined
  }) => {
    const response = await httpClient.post('auth/two-factor-challenge', {
      code,
      recovery_code: recoveryCode,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
    onSuccess: (res, variables) => {
      toast.success(' Two factor authentication completed')
      authenticate(true)
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
